module.exports = __webpack_public_path__ + "media/npc_dota_hero_chen.0b123acd.webm";